import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["template", "destination"];
  static values = { placeholder: { type: String, default: "NEW_RECORD" } };

  copy() {
    const content = this.templateTarget.innerHTML.replaceAll(
      this.placeholderValue,
      new Date().getTime(),
    );

    this.destinationTarget.insertAdjacentHTML("beforeend", content);
    this.destinationTarget.lastElementChild
      ?.querySelector("input:not([type=hidden]), textarea, select")
      ?.focus();
  }
}
